<template>
    <div class="role-select">
        <div class="d-flex align-items-center">
            <div class="button-wrap">
                <ul v-if="buttonTrigger" class="role-select-ul">
                    <li 
                        v-for="(option, index) in selectOption" 
                        :key="index" 
                        @click="changeSelection(index)"
                        :class="option.slug == sessionDefault.slug ? 'selected' : ''"
                    >{{ option.label }}</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>

import { mapState, mapActions } from 'vuex';

export default {
    data() {
        return {
            buttonTrigger: true,
            sessionDefault: {
                label: 'JUMP DECK ON',
                slug: 'JD-ON'
            }
        }
    },
    computed: {
        ...mapState([]),
        trigered() {
            return this.buttonTrigger ? 'triggered' : '';
        },
        selectOption() {
            return [
                {
                    label: 'JUMP DECK ON',
                    slug: 'JD-ON'
                },
                {
                    label: 'JUMP DECK OFF',
                    slug: 'JD-OFF'
                },
                {
                    label: 'TOWERCLIMB GROUP',
                    slug: 'TC'
                },
                {
                    label: 'SKYWALK GROUP',
                    slug: 'SW'
                }
            ];
        }
    },
    methods: {
        ...mapActions(['setNFCRoleSession']),
        triggerRoleSelection() {
            this.buttonTrigger = !this.buttonTrigger
        },
        async changeSelection(index) {
            this.sessionDefault = this.selectOption[index];
            await this.setNFCRoleSession(this.sessionDefault)
        }
    },
    async mounted() {
        await this.setNFCRoleSession(this.sessionDefault)
    }
}
</script>

<style lang="scss">
    .role-select {
        margin-top: 100px;
        margin-bottom: -50px;

        label {
            font-size: 11px;
            color: #FFF;
            font-family: Montserrat;
            font-weight: bold;
            text-transform: uppercase;
        }

        .button-parent {
            position: relative;
        }

        button {
            background: none;
            outline: none;
            border: none;
            font-family: Montserrat;
            font-weight: bold;
            font-size: 11px;
            color: #FFF;
            text-transform: uppercase;
            padding: 9px 0px 9px 16px;
            display: flex;
            align-items: center;
            cursor: pointer;

            &:after {
                content: "\E805";
                font-family: fontawesome;
                color: #fff;
                font-size: 11px;
                margin-left: 5px;
            }

            &.triggered {
                &:after {
                    content: "\E808";
                }
            }
        }

        // ul.role-select-ul {
        //     list-style: none;
        //     position: absolute;
        //     top: 100%;
        //     right: 0;
        //     width: 145px;
        //     border: 1px solid #000;
        //     border-top: 0;


        //     li {
        //         font-size: 12px;
        //         color: #393939;
        //         background: #fff;
        //         padding: 9px;
        //         font-weight: bold;
        //         cursor: pointer;
        //         text-transform: uppercase;

        //         &:hover {
        //             background: #ecebeb;
        //         }

        //         &.selected {
        //             background: #f0efef;
        //         }
        //     }
        // }
        

        ul.role-select-ul {
            display: flex;
            align-items: center;
            justify-content: center;

            li {
                background: #EDEDED;
                border-radius: 2.99px;
                width: 157px;
                height: 145px;
                padding: 13px;
                font-family: 'Montserrat';
                font-weight: 800;
                font-size: 17px;
                color: #393939;
                text-align: center;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-right: 10px;

                &:last-child {
                    margin-right: 0;
                }

                &.selected {
                    background: #FFC20F;
                }
            }
        }
    }
</style>
